import { bem } from 'mission-control-common-components';
import ReactTooltip from 'react-tooltip';
import { useEffectOnce } from 'react-use';

import ClipboardButton from '../../../ClipboardButton';

const [, element] = bem('creative-rejection-reasons-modal');

const REASONS_FOR_REJECTION_LABEL = 'Reasons for Rejection';
const CLIPBOARD_TOOLTIP_MESSAGE = 'Copy rejection reasons';

type Props = {
  copyText: () => Promise<void>;
};

const CreativeRejectionReasonsModalTitle = ({ copyText }: Props): React.JSX.Element => {
  useEffectOnce(() => {
    ReactTooltip.rebuild();
  });

  return (
    <div className={element('modal-title-wrapper')}>
      <div className={element('modal-title')}>{REASONS_FOR_REJECTION_LABEL}</div>
      <div className={element('clipboard-wrapper')}>
        <ClipboardButton copyText={copyText} tooltipText={CLIPBOARD_TOOLTIP_MESSAGE} />
      </div>
    </div>
  );
};

export default CreativeRejectionReasonsModalTitle;
